import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";
import './styles.css'; // 引入全局样式文件
import "./assets/style/common.css";
// src/main.js
import axiosInstance from '@/utils/request'

Vue.prototype.axios = axiosInstance; // 保持与原有代码一致的调用方式


Vue.prototype.$message = function (options) {
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  return ElementUI.Message({
    duration: 2000, // 默认 2 秒
    ...options
  });
};

// 扩展 $message.success() / $message.error() 等快捷方法
['success', 'warning', 'error', 'info'].forEach(type => {
  Vue.prototype.$message[type] = (message) => {
    return ElementUI.Message({
      message,
      type,
      duration: 2000
    });
  };
});


Vue.directive('no-space', {
  inserted(el) {
    if (el.querySelector('input')) {
      const input = el.querySelector('input');
      
      input.addEventListener('input', (e) => {
        // 去除头尾空格
        let newValue = e.target.value.trim();
        
        // 如果去除空格后为空，且原始值包含空格（即全为空格的情况）
        if (newValue === '' && /\s/.test(e.target.value)) {
          newValue = ''; // 设置为空
        }
        
        // 检查值是否改变
        if (e.target.value !== newValue) {
          e.target.value = newValue;
          // 触发 input 事件以更新 v-model
          e.target.dispatchEvent(new Event('input'));
        }
      });
      
      // 添加 blur 事件处理，确保失去焦点时也处理
      input.addEventListener('blur', (e) => {
        let newValue = e.target.value.trim();
        if (e.target.value !== newValue) {
          e.target.value = newValue;
          e.target.dispatchEvent(new Event('input'));
        }
      });
    }
  }
});
// 粒子
import VueParticles from "vue-particles";
Vue.use(VueParticles);

// 引入axios
import axios from "axios";

// 存储防抖队列
const debounceMap = new Map();

// 生成请求唯一标识（可根据业务调整）
function generateRequestKey(config) {
  return `${config.method}-${config.url}-${JSON.stringify(config.params)}-${JSON.stringify(config.data)}`;
}

// 防抖延迟时间（单位：ms）
const DEBOUNCE_DELAY = 300;

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 如果标记了 noDebounce，直接放行
    if (config.noDebounce) {
      return config;
    }
    const requestKey = generateRequestKey(config);

    // 如果已有相同请求在防抖中，取消它的防抖计时器
    if (debounceMap.has(requestKey)) {
      const { timer, source } = debounceMap.get(requestKey);
      clearTimeout(timer); // 清除旧计时器
      source.cancel('取消旧防抖请求'); // 取消旧请求（如果已发出但未完成）
    }

    // 创建新的 CancelToken
    const source = axios.CancelToken.source();

    // 返回一个 Promise，在防抖延迟后真正发出请求
    return new Promise((resolve) => {
      const timer = setTimeout(() => {
        debounceMap.delete(requestKey); // 防抖完成，清理记录
        config.cancelToken = source.token; // 绑定 CancelToken
        resolve(config); // 真正发出请求
      }, DEBOUNCE_DELAY);

      // 存储防抖信息
      debounceMap.set(requestKey, { timer, source });
    });
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器（清理防抖记录）
axios.interceptors.response.use(
  (response) => {
    const requestKey = generateRequestKey(response.config);
    debounceMap.delete(requestKey); // 请求完成，清理防抖记录
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      console.log('请求被取消（防抖生效）:', error.message);
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);
Vue.prototype.axios = axios;


// 设置Axios请求拦截器
axios.interceptors.request.use(function (config) {
  let token = sessionStorage.getItem("token"); // 获取到从后端传来的token，然后存到session里面
  if (token) {
    config.headers["token"] = token; // 然后赋值就行
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// 设置Axios响应拦截器
axios.interceptors.response.use(async function (response) {
  if (response.data.code === 1001 && response.data.info === "token过期!" && !store.state.isShowingTokenExpiredPrompt) {
    store.commit('setIsShowingTokenExpiredPrompt', true);
    try {
      sessionStorage.removeItem('token');
      try {
        const res = await axios.get("/api2/user/token");

        if (res.data && res.data.data) {
          window.sessionStorage.setItem("token", res.data.data);
          let token = window.sessionStorage.getItem("token");
          console.log("Token 获取成功:", token);
          if (token) {
            this.getData();
          }
        } else {
          console.warn("Token 数据为空:", res);
        }
      } catch (error) {
        console.error("请求 Token 失败:", error);
      }
    } catch (e) {
      // 用户取消操作
    } finally {
      store.commit('setIsShowingTokenExpiredPrompt', false);
    }
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});

// 引入echarts
import * as echarts from "echarts";
Vue.prototype.echarts = echarts;

// 引入ElementUI组件
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");


